import React from "react";
const Preset2 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("rect", { x: "28", y: "20", width: "56", height: "72", rx: "4", fill: "#E9F0FF" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M28 24C28 21.7909 29.7909 20 32 20H80C82.2091 20 84 21.7909 84 24V64H28V24Z",
        fill: "url(#paint0_linear_6001_4804)"
      }
    ),
    /* @__PURE__ */ React.createElement("circle", { cx: "47", cy: "39", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M38.2932 46.9011L28 55.1837V62C28 63.1046 28.8954 64 30 64H82C83.1046 64 84 63.1046 84 62V50.2857L73.0981 41.5134C72 40.6297 70.4348 40.6297 69.3367 41.5134L52.3478 55.1837L42.0546 46.9011C40.9565 46.0175 39.3913 46.0175 38.2932 46.9011Z",
        fill: "url(#paint1_linear_6001_4804)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "33", y: "24", width: "20", height: "6", rx: "3", fill: "#000624" }),
    /* @__PURE__ */ React.createElement("rect", { x: "33", y: "73", width: "46", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M33 80.5C33 79.6716 33.6716 79 34.5 79C35.3284 79 36 79.6716 36 80.5C36 81.3284 35.3284 82 34.5 82C33.6716 82 33 81.3284 33 80.5Z",
        fill: "#000624",
        fillOpacity: "0.3"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M37 80.5C37 79.6716 37.6716 79 38.5 79H44.5C45.3284 79 46 79.6716 46 80.5C46 81.3284 45.3284 82 44.5 82H38.5C37.6716 82 37 81.3284 37 80.5Z",
        fill: "#000624",
        fillOpacity: "0.3"
      }
    ),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4804",
        x1: "56",
        y1: "20",
        x2: "56",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4804",
        x1: "56",
        y1: "40",
        x2: "56",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset2
};
//# sourceMappingURL=Preset2.js.map
